<template>
  <table
    v-if="itemDataDetails.paymentstatus"
    class="min-w-full table-fixed divide-y divide-gray-200 border border-gray-300 rounded-md overflow-hidden text-sm"
  >
    <tbody class="divide-y divide-gray-200">
      <tr
        v-for="(value, key) in itemSummary"
        :key="key"
        class="odd:bg-white even:bg-gray-50"
      >
        <td class="px-4 py-2 font-semibold w-1/3">{{ key }}</td>
        <td class="px-4 py-2 text-gray-700 w-2/3">
          <template v-if="key === 'Proof of Payment'">
            <img
              :src="proofImageUrl"
              alt="Proof of Payment"
              class="w-auto h-48 object-cover border rounded"
            />
          </template>
          <template v-else>
            {{ value }}
          </template>
        </td>
      </tr>
    </tbody>
  </table>
  <div v-else class="text-slate-500 text-sm">
    No payment information has been provided yet.
  </div>
</template>

<script>
import { computed, inject, onMounted, ref } from "vue";
export default {
  props: {
    itemDataDetails: Object,
  },
  setup(props) {
    const axios = inject("$axios");
    const proofImageUrl = ref(null);
    const keyMap = {
      paymentpayee: "Name of Payee",
      reimbursableamount: "Guaranteed Amount",
      paymentprovider: ["Gcash", "Paymaya", "Bank Transfer"].includes(
        props.itemDataDetails.paymentprovider
      )
        ? "Payment Channel"
        : "Bank Name",
      paymentaccount: "Account Number",
      paymentstatus: "Status",
      paymentreference: "Proof of Payment",
    };

    const excludedKeys = [
      "requestedamount",
      "transactionnumber",
      "company",
      "membername",
      "availmenttype",
      "transtype",
      "providername",
      "admitdate",
      "dischargedate",
      "symptoms",
      "contactperson",
      "remarks",
      "AttachmentFiles",
      "renderstartdate",
      "paymentdate",
      "graceperiod",
      "approvaltype",
      "createdbyid",
      "modifiedbyid",
      "createdAt",
      "updatedAt",
      "admin",
      "Status",
      "requestdate",
      "declinedreason",
    ];

    onMounted(() => {
      handlerProofOfPayment();
    });
    const modified = (key, val) => {
      if (["requestedamount", "reimbursableamount"].includes(key)) {
        const number = Number(val);
        if (!isNaN(number)) {
          return `₱ ${number.toLocaleString("en-PH", {
            minimumFractionDigits: 2,
          })}`;
        }
      }
      return val;
    };

    const itemSummary = computed(() => {
      const topEntries = Object.entries(keyMap)
        .filter(([key]) => props.itemDataDetails[key] !== undefined)
        .map(([key, label]) => [
          label,
          modified(key, props.itemDataDetails[key]),
        ]);

      const filteredEntries = Object.entries(props.itemDataDetails)
        .filter(
          ([key]) =>
            !excludedKeys.includes(key) && !Object.keys(keyMap).includes(key)
        )
        .map(([key, value]) => [keyMap[key] || key, modified(key, value)]);

      return Object.fromEntries([...topEntries, ...filteredEntries]);
    });

    const handlerProofOfPayment = async () => {
      try {
        const response = await axios.get(
          `/portal/application/reimbursement/payment/attachment`,
          {
            params: {
              filename: props.itemDataDetails.paymentreference,
            },
            responseType: "blob",
          }
        );
        console.log(response.data);

        proofImageUrl.value = URL.createObjectURL(response.data);
      } catch (error) {
        console.error("Failed to fetch profile image:", error);
      }
    };

    return {
      itemSummary,
      modified,
      proofImageUrl,
      handlerProofOfPayment,
    };
  },
};
</script>
